interface CrewPrintData {
  name: string;
  rank: string;
  nationality: string;
  dateOfBirth: string;
  seamanBookNo: string;
  seamanBookExpiry: string;
  dateOfJoin: string;
}

interface VesselPrintInfo {
  vesselName: string;
  location: string;
  callSign: string;
  imoNumber: string;
  flag: string;
  date: string;
}

export function openCrewListPrintWindow(vesselInfo: VesselPrintInfo, crewData: CrewPrintData[]) {
  const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Crew List</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
            font-size: 12px;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
            border: 2px solid #000;
            padding: 10px;
          }
          .header h1 {
            font-size: 18px;
            font-weight: bold;
          }
          .vessel-info {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            margin-bottom: 20px;
            border: 1px solid #000;
            padding: 10px;
          }
          .vessel-info-row {
            display: flex;
            border-bottom: 1px solid #ccc;
            padding: 5px 0;
          }
          .vessel-info-row:last-child {
            border-bottom: none;
          }
          .vessel-info-label {
            font-weight: bold;
            min-width: 120px;
          }
          .vessel-info-value {
            flex: 1;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          th {
            background-color: #d9d9d9;
            border: 1px solid #000;
            padding: 8px 5px;
            text-align: center;
            font-weight: bold;
            font-size: 11px;
          }
          td {
            border: 1px solid #000;
            padding: 6px 5px;
            text-align: center;
            font-size: 11px;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          @media print {
            body {
              padding: 10px;
            }
            @page {
              margin: 1cm;
              size: landscape;
            }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>F.06.03.02&nbsp;&nbsp;&nbsp;CREW LIST</h1>
        </div>
        
        <div class="vessel-info">
          <div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">Vessel Name:</span>
              <span class="vessel-info-value">${vesselInfo.vesselName}</span>
            </div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">Location:</span>
              <span class="vessel-info-value">${vesselInfo.location}</span>
            </div>
          </div>
          <div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">Call Sign:</span>
              <span class="vessel-info-value">${vesselInfo.callSign}</span>
            </div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">Date:</span>
              <span class="vessel-info-value">${vesselInfo.date}</span>
            </div>
          </div>
          <div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">IMO NO.:</span>
              <span class="vessel-info-value">${vesselInfo.imoNumber}</span>
            </div>
          </div>
          <div>
            <div class="vessel-info-row">
              <span class="vessel-info-label">Flag:</span>
              <span class="vessel-info-value">${vesselInfo.flag}</span>
            </div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Rank</th>
              <th>Nationality</th>
              <th>Date of birth</th>
              <th>Seaman's book No.</th>
              <th>Expiry date of Seaman's book</th>
              <th>Date of join</th>
            </tr>
          </thead>
          <tbody>
            ${crewData.map(crew => `
              <tr>
                <td>${crew.name}</td>
                <td>${crew.rank}</td>
                <td>${crew.nationality}</td>
                <td>${crew.dateOfBirth}</td>
                <td>${crew.seamanBookNo}</td>
                <td>${crew.seamanBookExpiry}</td>
                <td>${crew.dateOfJoin}</td>
              </tr>
            `).join('')}
            ${crewData.length === 0 ? '<tr><td colspan="7" style="text-align: center; padding: 20px;">No crew members found</td></tr>' : ''}
          </tbody>
        </table>

        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  }
}
